/* GIAW Theme — Main JavaScript */
(function() {
  'use strict';

  /* ── FORMAT MONEY ── */
  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  /* ── PANELS / MODALS ── */
  window.openPanel = function(id) {
    var el = document.getElementById(id);
    if (el) { el.classList.add('open'); document.body.style.overflow = 'hidden'; }
  };
  window.closePanel = function(id) {
    var el = document.getElementById(id);
    if (el) { el.classList.remove('open'); document.body.style.overflow = ''; }
  };
  window.openModal = function(id) {
    var el = document.getElementById(id);
    if (el) { el.classList.add('open'); document.body.style.overflow = 'hidden'; }
  };
  window.closeModal = function(id) {
    var el = document.getElementById(id);
    if (el) { el.classList.remove('open'); document.body.style.overflow = ''; }
  };
  window.closeMob = function() {
    var el = document.getElementById('mob-nav');
    if (el) { el.classList.remove('open'); document.body.style.overflow = ''; }
  };

  /* ── TOAST ── */
  window.showToast = function(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.style.opacity = '1';
    clearTimeout(t._t);
    t._t = setTimeout(function() { t.style.opacity = '0'; }, 2400);
  };

  /* ── SIZE PICKER ── */
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('sz')) {
      var row = e.target.closest('.sizes-row');
      if (row) {
        row.querySelectorAll('.sz').forEach(function(b) { b.classList.remove('on'); });
        e.target.classList.add('on');
      }
    }
  });

  /* ── AJAX CART ── */
  window.addToCart = function(variantId, qty) {
    qty = qty || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      showToast((item.title || 'Item') + ' added to cart');
      updateCartBadge();
      refreshCartPanel();
      openPanel('cart-panel');
    })
    .catch(function() { showToast('Could not add to cart'); });
  };

  window.updateCartBadge = function() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-badge').forEach(function(b) {
        b.textContent = cart.item_count;
      });
    });
  };

  window.refreshCartPanel = function() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var body = document.getElementById('cart-body');
      if (!body) return;

      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<div class="cart-empty-msg">Your cart is empty</div>';
        return;
      }

      var html = '';
      cart.items.forEach(function(item) {
        var img = item.image ? '<img class="ci-thumb" src="' + item.image + '" alt="' + item.title + '" width="60" height="60" style="object-fit:cover;">' : '<div class="ci-thumb" style="background:#222;width:60px;height:60px;"></div>';
        html += '<div class="cart-item">' +
          img +
          '<div>' +
            '<p class="ci-name">' + item.product_title + '</p>' +
            '<p class="ci-meta">' + (item.variant_title && item.variant_title !== 'Default Title' ? 'SIZE: ' + item.variant_title : '') + '</p>' +
            '<div class="qty-row">' +
              '<button class="qbtn" onclick="changeCartQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>' +
              '<span class="qnum">' + item.quantity + '</span>' +
              '<button class="qbtn" onclick="changeCartQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px">' +
            '<span class="ci-price">' + formatMoney(item.final_line_price) + '</span>' +
            '<button class="ci-del" onclick="changeCartQty(\'' + item.key + '\',0)">✕</button>' +
          '</div>' +
        '</div>';
      });

      var freeShipping = false
      var shipping = freeShipping ? 'Free' : formatMoney(9900);
      var total = freeShipping ? cart.total_price : cart.total_price + 9900;

      html += '<div class="cart-footer">' +
        '<div class="cf-row"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<div class="cf-row"><span>Shipping</span><span>' + shipping + '</span></div>' +
        '<div class="cf-total"><span>Total</span><span>' + formatMoney(total) + '</span></div>' +
        '<a href="/checkout" class="btn-filled" style="width:100%;margin-top:18px;text-align:center;display:block">Checkout</a>' +
      '</div>';

      body.innerHTML = html;
    })
    .catch(function() {
      var body = document.getElementById('cart-body');
      if (body) body.innerHTML = '<div class="cart-empty-msg">Could not load cart</div>';
    });
  };

  window.changeCartQty = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function() {
      updateCartBadge();
      refreshCartPanel();
    });
  };

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function() {
    updateCartBadge();
  });

})();
